export default __webpack_public_path__ + "static/media/footerbg.537fb969.jpg";